<template v-if="selectedData.length > 0">
    <div class="faq-area">
        <div class="blog-title mb-5">
          <!-- <span class="sub-title-shadow text-capitalize">Asked Questions</span> -->
            <h4>
                Frequently Asked Questions
                <img src="../../assets/images/faq-sign.png" alt="faq sign">
            </h4>
            
        </div>
        <div class="container">
            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="faq-accordion">
                        <Accordion>
                            <AccordionItem v-for="questionData in selectedData" :key="questionData.title">
                                <template v-slot:accordion-trigger>
                                    <button class="accordion-title" style="font-size: 24px;">
                                        {{ questionData?.title }}
                                    </button>
                                </template>
                                <template v-slot:accordion-content>
                                    <div class="accordion-body" style="font-size: 18px" v-html="questionData?.description">
                                       
                                    </div>
                                </template>
                            </AccordionItem>
                          
                        </Accordion>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>





<script>
import Accordion from "../Common/Accordion";
import AccordionItem from "../Common/AccordionItem";
export default {
    name: 'Faq',
    components: {
        Accordion,
        AccordionItem,
    },
    props: {
        faq_Data: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            selectedData:[],
            isLoading: false
        }
    },
    mounted() {
        if (this.faq_Data && this.faq_Data.length > 0) {
            this.selectedData = this.faq_Data; // Set default category
        }
    },
    watch: {
        faq_Data: {
            handler(newData) {
                if (newData && newData.length > 0) {
                    this.selectedData = newData;
                }
            },
            immediate: true
        }
    }

}
</script>